import axios from 'axios';

// ACTION TYPES
const name = 'websites';
export const actionTypes = {
  SET_WEBSITES: `${name}:set_websites`,
  SET_SELECTED_WEBSITE: `${name}:set_selected_website`,
  SET_FILTER_WEBSITE: `${name}:set_filter_website`,
  SET_SORT_BY: `${name}:set_sort_by`,
  SET_SORT_DIR: `${name}:set_sort_dir`,
  SET_PAGE_NUM: `${name}:set_page_num`,
  SET_UPDATE_IN_PROGRESS: `${name}:set_update_in_progress`,
  SET_UPDATE_COMPLETE: `${name}:set_update_complete`,
  UPDATE_WEBSITE: `${name}:update_website`,
};

// ACTIONS
export function addWebsite(website, edit=false) {
  return (dispatch, getState) => {
    const request = {
      method: 'POST',
      url: `${getState().params.apiUrl}/webaccs/`,
      headers: {
        Authorization: `Token ${getState().params.token}`,
      },
      data: website,
    };
    return axios(request)
      .then(response => {
        if(edit) {
          dispatch(setSelectedWebsite(response.data));
        }
        dispatch(loadWebsites());
      })
      .catch(error => {
        console.log(error);
      });
  };
}

export function loadWebsites() {
  return (dispatch, getState) => {
    // set filtering params
    const website = getState().websites.filterWebsite;
    const params = {
      limit: 200, 
    };
    params.lastName = website.lastName ? website.lastName : '';
    params.firmName = website.firmName ? website.firmName : '';
    params.websiteUrl = website.websiteUrl ? website.websiteUrl : '';
    params.completed = website.completed;
    params.sortBy = getState().websites.sortBy;
    params.sortDir = getState().websites.sortDir;
    //make request
    const request = {
      method: 'GET',
      url: `${getState().params.apiUrl}/webaccs/`,
      headers: {
        Authorization: `Token ${getState().params.token}`,
      },
      params: params,
    };
    return axios(request)
      .then((response) => {
        dispatch({ type: actionTypes.SET_WEBSITES, value: response.data });
      })
      .catch((error) => {
        console.error(error);
      });
  };
}

export function setSelectedWebsite(website) {
  return (dispatch) => {
    dispatch({ type: actionTypes.SET_SELECTED_WEBSITE, value: website });
  };
}

export function setFilterWebsite(website) {
  return (dispatch) => {
    dispatch({ type: actionTypes.SET_FILTER_WEBSITE, value: website });
    dispatch(loadWebsites());
  };
}

export function saveWebsite(website) {
  return (dispatch, getState) => {
    const request = {
      method: 'PUT',
      url: `${getState().params.apiUrl}/webaccs/${website.id}/`,
      headers: {
        Authorization: `Token ${getState().params.token}`,
      },
      data: website,
    };
    return axios(request)
      .then(response => {
        // dispatch(loadWebsites());
      })
      .catch(error => {
        console.log(error);
      });
  };
}

export function analyzeWebsite(website) {
  return (dispatch, getState) => {
    const request = {
      method: 'PUT',
      url: `${getState().params.apiUrl}/webaccs/${website.id}/analyze/`,
      headers: {
        Authorization: `Token ${getState().params.token}`,
      },
      data: website,
    };
    return axios(request)
      .then(() => {
        // dispatch(loadWebsites());
      })
      .catch(error => {
        console.log(error);
      });
  };
}

export function downloadReport(website) {
  return (dispatch, getState) => {
    const request = {
      method: 'GET',
      responseType: 'blob',
      url: `${getState().params.apiUrl}/webaccs/${website.id}/report/`,
      headers: {
        Authorization: `Token ${getState().params.token}`,
      },
    };
    return axios(request)
      .then(response => {
        const blob = new Blob([response.data], {type: 'application/pdf'});
        const data = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = data;
        link.download = `WA_${website.firstName}_${website.lastName}_${website.firmName.replace(/\s+/g,'')}.pdf`;
        link.click();
      })
      .catch(error => {
        console.log(error);
      });
  };
}

export function downloadReports(websites) {
  const ids = websites.map((website) => website.id);
  return (dispatch, getState) => {
    const request = {
      method: 'POST',
      responseType: 'blob',
      url: `${getState().params.apiUrl}/webaccs/reports/`,
      headers: {
        Authorization: `Token ${getState().params.token}`,
      },
      data: ids
    };
    return axios(request)
      .then(response => {
        const blob = new Blob([response.data], {type: 'application/zip'});
        const data = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = data;
        link.download = `WA_Reports.zip`;
        link.click();
      })
      .catch(error => {
        console.log(error);
      });
  };
}

export function deleteWebsite(website) {
  return (dispatch, getState) => {
    const request = {
      method: 'DELETE',
      url: `${getState().params.apiUrl}/webaccs/${website.id}/`,
      headers: {
        Authorization: `Token ${getState().params.token}`,
      },
    };
    return axios(request)
      .then(() => {
        dispatch(loadWebsites());
      })
      .catch(error => {
        console.log(error);
      });
  };
}

export function deleteWebsites(websites) {
  const ids = websites.map((website) => website.id);
  return (dispatch, getState) => {
    const request = {
      method: 'POST',
      url: `${getState().params.apiUrl}/webaccs/delete/`,
      headers: {
        Authorization: `Token ${getState().params.token}`,
      },
      data: ids
    };
    return axios(request)
      .then(() => {
        dispatch(loadWebsites());
      })
      .catch(error => {
        console.log(error);
      });
  };
}

export function setSort(field, direction) {
  return (dispatch) => {
    dispatch({ type: actionTypes.SET_SORT_BY, value: field });
    dispatch({ type: actionTypes.SET_SORT_DIR, value: direction });
    dispatch(loadWebsites());
  };
}

export function setPageNum(value) {
  return (dispatch) => {
    dispatch({ type: actionTypes.SET_PAGE_NUM, value: value });
  };
}
